import { CustomProductSubscriptionDto } from "@aihCustomBlueprint/Handlers/AihCustomProductSubscribe/CustomProductSubscriptionDto";
import { getSubscriptions } from "@aihCustomBlueprint/Services/AihProductSubscriptionService";
import { AIHActions } from "@aihCustomBlueprint/Store/CustomApplicationState";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    GetProductCollectionApiV2Parameter,
    getProductCollectionV2,
} from "@insite/client-framework/Services/ProductServiceV2";
import { ProductDto, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { DispatchProp } from "react-redux";

export type SubscriptionProps = {
    allSubscribedProducts?: ProductDto[] | null;
    notificationProducts?: CustomProductSubscriptionDto[] | null;
    allSubscribedProductsModel?: ProductModel[] | null;
};

type HandlerType = ApiHandler<
    {} & HasOnSuccess<ProductModel[]> & HasOnError<string>,
    ServiceResult<CustomProductSubscriptionDto[] | ProductModel[] | null>,
    DispatchProp<AIHActions>
>;

export const LoadAllProductSubscriptions: HandlerType = async props => {
    props.dispatch({
        type: "Subscriptions/BeginLoad",
    });

    props.apiResult = await getSubscriptions(); // out of stock
};

export const LoadProductCollection: HandlerType = async props => {
    if (!props.apiResult.successful) {
        return;
    }

    if (Array.isArray(props.apiResult.result) && props.apiResult.result.length <= 0) {
        return;
    }

    const productDtoResult = props.apiResult.result as CustomProductSubscriptionDto[];

    const ids = productDtoResult?.map(x => x.ProductId);

    const param: GetProductCollectionApiV2Parameter = {
        productIds: ids,
    };

    const productCollectionResult = await getProductCollectionV2(param);

    props.apiResult.result = productCollectionResult.products;
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult.result as ProductModel[]);
    }
};
export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const chain = [
    LoadAllProductSubscriptions,
    LoadProductCollection,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
];

const loadAllProductSubscriptions = createHandlerChainRunner(chain, "loadAllProductSubscriptions");
export default loadAllProductSubscriptions;
